import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import moment from "moment-timezone";

const COLORS = [
  "#FF5733", "#33A1FF", "#28C76F", "#FFC107",
  "#8E44AD", "#E91E63", "#00BCD4", "#FF9800",
];

const TIME_CHECK_INTERVAL = 30000;
const TIMEZONE = process.env.REACT_APP_DISPLAY_TIMEZONE;
const DATE_FORMAT = process.env.REACT_APP_LONG_TIME_FORMAT;

const isValidDate = (dateStr) => {
  if (!dateStr) return false;
  if (typeof dateStr === "string" && dateStr.trim().startsWith("0000-00-00")) {
    return false;
  }
  const parsed = moment(dateStr);
  return parsed.isValid() && parsed.year() > 1970;
};

const AnnouncementMarquee = () => {
  const { announcementResult } = useSelector((state) => state.announcement);
  const rawData = Array.isArray(announcementResult) ? announcementResult : [];

  const [now, setNow] = useState(moment().tz(TIMEZONE));

  useEffect(() => {
    const clockTimer = setInterval(() => {
      setNow(moment().tz(TIMEZONE));
    }, TIME_CHECK_INTERVAL);
    return () => clearInterval(clockTimer);
  }, []);

  const activeAnnouncements = rawData.filter((item) => {
    if (!item) return false;
    if (item.IsActive !== 1) return false;

    const hasValidStart = isValidDate(item.StartDate);
    const hasValidEnd = isValidDate(item.EndDate);

    const start = hasValidStart ? moment.tz(item.StartDate, TIMEZONE) : null;
    const end = hasValidEnd ? moment.tz(item.EndDate, TIMEZONE) : null;

    if (start && now.isBefore(start)) return false;
    if (end && now.isAfter(end)) return false;

    return true;
  });

  const hasAnnouncement = activeAnnouncements.length > 0;

  useEffect(() => {
    if (hasAnnouncement) {
      document.body.classList.add("has-announcement-marquee");
    } else {
      document.body.classList.remove("has-announcement-marquee");
    }
    return () => document.body.classList.remove("has-announcement-marquee");
  }, [hasAnnouncement]);

  if (!hasAnnouncement) return null;

  const REPEAT_COUNT = 8;
  const loopList = Array.from({ length: REPEAT_COUNT }).flatMap(() => activeAnnouncements);

  return (
    <div className="announcement-marquee-wrapper">
      <div className="announcement-marquee-track">
        {loopList.map((item, index) => {
          if (!item) return null;

          const colorIndex = index % activeAnnouncements.length;
          return (
            <span
              key={`${item.ID ?? index}-${index}`}
              className="announcement-marquee-item"
              style={{ "--item-color": COLORS[colorIndex % COLORS.length] }}
            >
              <span className="announcement-dot"></span>
              {item.Description}
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default AnnouncementMarquee;